module.exports = __webpack_public_path__ + "assets/img/a4e72ffb46f26cefe65dc9915dfd8cd2.png";